const payment = {
  title: 'Zahlungsart',
  methods: {
    bill: {
      title: 'Rechnung',
      desc: 'Bezahlen Sie bequem und sicher auf Rechnung (7 Tage Zahlungsziel nach Erhalt der Ware).',
      img: {
        src: require('../../../../assets/img/icons/bill.svg'),
        alt: 'Rechnung'
      },
      value: 'Rechnung'
    },
    paypal: {
      title: 'PayPal',
      desc: 'Bezahlen Sie per PayPal. Dazu erhalten Sie nach Prüfung und Bearbeitung einen Zahlungslink.',
      img: {
        src: 'https://www.paypalobjects.com/webstatic/ppplus/images/paypal-logo-100x26.png',
        alt: 'PayPal'
      },
      value: 'PayPal'
    }
  },
  summary: {
    title: 'Bestellübersicht',
    sum: 'Summe',
    taxBefore: '(inkl.',
    taxAfter: 'MwSt.)',
    total: 'zu zahlen'
  },
  coupon: {
    title: 'Gutschein-/Rabattcode eingeben',
    error: 'Dieser Code ist leider ungültig.'
  }
}

export default {
  payment
}
